import { createFileRoute, redirect } from '@tanstack/react-router'

import { ScoreSettingsPage } from '@/pages/team/ScoreSettings.page'
import { getIsScoreSettingsEnabled } from '@/stores/features.store'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/score-settings',
)({
  component: ScoreSettingsPage,
  beforeLoad: () => {
    if (!getIsScoreSettingsEnabled()) {
      throw redirect({
        to: '/',
      })
    }
  },
  loader: () => ({ breadcrumbTitle: 'Score Settings' }),
})
